$(document).ready(function () {
    handleLikeProduct();
    handleOpenModal();
    handleChangeQuantity();
    handleCheckNumberInStock();
    handleCloseModal();
    handleRegisterForm();
    showShareBox()
    handleHoverSocialItem();
});

function handleHoverSocialItem() {
    $('.share-social__icon').hover(function () {
        $(this).parent().addClass('--active');
    }, function () {
        $(this).parent().removeClass('--active');
    });
}

function showShareBox() {
    let isActivated = false; // Biến theo dõi trạng thái kích hoạt
    let hoverTimeout; // Timeout để delay việc ẩn box

    // Đảm bảo box social được ẩn mặc định
    $('.share-box .share-social').removeClass('show').addClass('hide');

    // Xử lý hover vào icon share - hiển thị box social
    $('#icon-share-box').hover(function () {
        isActivated = true; // Đánh dấu đã kích hoạt
        clearTimeout(hoverTimeout); // Hủy timeout nếu có
        $('.share-box .share-social').removeClass('hide').addClass('show');
    });

    // Xử lý hover vào box social - giữ nguyên hiển thị
    $('.share-box .share-social').hover(function () {
        if (isActivated) {
            clearTimeout(hoverTimeout); // Hủy timeout nếu có
            $('.share-box .share-social').removeClass('hide').addClass('show');
        }
    }, function () {
        // Delay việc ẩn box để có thời gian di chuyển chuột
        hoverTimeout = setTimeout(function () {
            isActivated = false;
            $('.share-box .share-social').removeClass('show').addClass('hide');
        }, 100);
    });

    // Xử lý hover ra khỏi toàn bộ share-box - ẩn box social và reset trạng thái
    $('.share-box').hover(function () {
        clearTimeout(hoverTimeout); // Hủy timeout nếu có
    }, function () {
        // Delay việc ẩn box để có thời gian di chuyển chuột
        hoverTimeout = setTimeout(function () {
            isActivated = false;
            $('.share-box .share-social').removeClass('show').addClass('hide');
        }, 100);
    });
}

function handleRegisterForm() {
    $('#form-register-information').on('submit', function (e) {
        e.preventDefault();
        handleRemoveMsgError();

        const name = $('#name').val();
        const quantity = $('#quantity-register-information').val();
        const phone = $('#phone').val();
        const email = $('#email').val();
        const content = $('#content').val();
        const product_id = $('#product-id-register-information').val();

        $.ajax({
            url: '/api/register-information',
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {
                name,
                phone,
                email,
                content,
                product_id,
                quantity
            },
            success: function (response) {
                if (response.status == 200) {
                    if ($('#register-information').length > 0) {
                        $('#register-information').modal('hide');
                        // Chờ modal đóng hoàn tất trước khi mở modal mới
                        setTimeout(() => {
                            $('.modal-backdrop').remove(); // Xóa backdrop
                            $('#register-success').modal('show');
                        }, 300); // Độ trễ 300ms để đảm bảo hiệu ứng đóng hoàn tất
                    } else {
                        $('.modal-backdrop').remove(); // Xóa backdrop
                        $('#register-success').modal('show');
                    }
                }
            },
            error: function (errors) {
                handleShowError(errors.responseJSON.data.errors);
            }
        });
    });

    // Xử lý khi modal #register-information đóng
    $('#register-information').on('hidden.bs.modal', function () {
        $('#form-register-information input').val('').removeClass('--invalid');
        $('#form-register-information textarea').val('').removeClass('--invalid');
        $('.msg').text('');
        $('.modal-backdrop').remove(); // Xóa backdrop
    });

    // Xử lý khi modal #register-success đóng
    $('#register-success').on('hidden.bs.modal', function () {
        $('#form-register-information input').val('').removeClass('--invalid');
        $('#form-register-information textarea').val('').removeClass('--invalid');
        $('.msg').text('');
        $('.modal-backdrop').remove(); // Xóa backdrop
        window.location.reload();
    });
}

function handleShowError(errors) {
    for (const key in errors) {
        $(`.msg-${key}`).text(errors[key][0]);
        $(`#${key}`).addClass('--invalid');
    }
}

function handleRemoveMsgError() {
    $('.msg').text('');
    $('input').removeClass('--invalid');
}

function handleCloseModal() {
    $('#btn-close-register-success').on('click', function () {
        $('#register-success').modal('hide');
        $('.modal-backdrop').remove(); // Xóa backdrop
        console.log('btn-close-register-success clicked, backdrop count:', $('.modal-backdrop').length);
    });
}

function handleCheckNumberInStock() {
    let numberInStock = $('#number-in-stock').val();
    if (numberInStock == 0) {
        $('.product-info').addClass('d-none');
    }
}

function handleChangeQuantity() {
    $('#quantity-up-register-information').on('click', function () {
        updateQuantity(1);
    });
    // Gắn sự kiện click cho nút giảm
    $('#quantity-down-register-information').on('click', function () {
        updateQuantity(-1);
    });

    // Gắn sự kiện click cho nút tăng
    $('#quantity-up').on('click', function () {
        updateQuantity(1);
    });
    // Gắn sự kiện click cho nút giảm
    $('#quantity-down').on('click', function () {
        updateQuantity(-1);
    });
    // Xử lý nhập trực tiếp từ bàn phím
    $('#quantity').on('input', function () {
        let value = parseInt($(this).val());
        if (isNaN(value) || value < 1) {
            $(this).val(1); // Đặt lại giá trị tối thiểu nếu không hợp lệ
        }
    });
}

function handleOpenModal() {
    $('.open-modal').on('click', function () {
        let productId = $('#product-id').val();
        let productName = $('#product-name').val();
        let input = $('#quantity');
        let value = parseInt(input.val()) || 1;

        $('#quantity-register-information').val(value);
        $('#product-id-register-information').val(productId);
        $('#product-name-register-information').text(productName);
    });
}


function updateQuantity(change) {
    let input = $('#quantity');
    let productId = $('#product-id').val();
    let productName = $('#product-name').val();

    let value = parseInt(input.val()) || 1;
    value += change;
    if (value < 1) value = 1; // Đảm bảo giá trị không nhỏ hơn 1
    input.val(value);
    $('#quantity-register-information').val(value);
    $('#product-id-register-information').val(productId);
    $('#product-name-register-information').text(productName);
}


function handleLikeProduct() {

    $('.like').on('click', function () {
        const productId = $(this).data('id');
        const url = `${window.location.origin}/api/handle-like`;

        $.ajax({
            url,
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {
                product_id: productId,
            },
            success: function (response) {

                if (response.status == 200) {

                    if (response.data.result?.like) {
                        updateLikeOnView(response.data.result.like);
                        $('.icon-heart').addClass('d-none');
                        $('.icon-heart-color').removeClass('d-none');

                        toastr.success(response.data.message);
                    } else {
                        toastr.info(response.data.message);
                    }
                }
            },
            error: function (errors) {
                handleShowError(errors.responseJSON.errors);
            }
        });
    });
}

function updateLikeOnView(value) {
    $('.like-number').text(value);
}
